// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_9w-4";
export var collapsed = "_9w-1";
export var headerBar = "_9w-0";
export var leftHeaderContent = "_9w-3";
export var subjectContainer = "_9w-2";